import React, {useState, useRef, useEffect, Fragment} from 'react';
import { postingEmail } from '../components/NodeMailer';
import VisDiv from './frontend_components/VisDiv';
import RichTextEditor from './RichTextEditor';
//import {RichTextEditor, VisDiv} from './';
import { keyId, commaSeparatedStringToArray } from '../lib/utils';
import draftToHtml from 'draftjs-to-html';
import TextField from './TextField';
import { successAlert, errorAlert } from '../lib/utils';
import { useStateContext } from '../context/StateContext'
import { v4 as uuidv4, v4 } from 'uuid';
import FieldDropdown from './FieldDropdown';
import PromiseQueue from 'p-queue'


/**
 * 
 * @param {*} emailTemplate "{
        subject: "string",
        htmlBody: "stringify html",
        richEditorObj: {} rich editor object,
        text: string,
        toEmail: sring of emails separated by comma
    }"
 * @returns 
 */

const RichEmail = ({emailTemplate, service = "aws", clients=[], emailType = "email"}) => {

     const {apiUrl, customerUsers} = useStateContext();
     const usersOptions = customerUsers?.map?.((user)=> ({label: `${user?.firstName} ${user?.lastName}`, value: user?.email}))
     const initialUsers = !emailTemplate?.toEmail ? [] : commaSeparatedStringToArray(emailTemplate?.toEmail)?.map?.(email => {
        const findUser = !Array.isArray(usersOptions) ? undefined : usersOptions?.find?.((x)=>x?.value?.trim() == email?.trim())
        return findUser
     });

     // PEC

     const clientsOptions = clients?.map?.((client)=> ({...client, value: client?.label}))
     const initialClients = !emailTemplate?.toEmail ? [] : commaSeparatedStringToArray(emailTemplate?.toEmail)?.map?.(pec => {
        const findClient = !Array.isArray(clientsOptions) ? undefined : clientsOptions?.find?.((x)=>x?.pec?.trim() == pec?.trim())
        return findClient
     });

     //=========

    const htmlVersion = (htmlDraft, _id) => {return `<html><body>${htmlDraft}<img src='${apiUrl}/email/tracker/${_id}' width='1' height='1' /></body></html>`}

    const emptyDoc = () =>{ 
        const _id = uuidv4()
        const campaignId = uuidv4()
        const doc = {
            campaignId,
            _id,
            subject: "",
            htmlBody: htmlVersion("undefined", _id),
            richEditorObj: {},
            text: "",
            toEmail: []
        }
        return doc
    }
    const initialDocument3 = () => {
            const users = initialUsers
          
        if(emailTemplate) {
            const template = emailTemplate
            const _id = template?._id ? template?._id : uuidv4()
            const campaignId = template?._campaignId ? template?.campaignId : uuidv4()
            const templateHtml = draftToHtml(template?.richEditorObj)
            const toEmail = users?.map?.(x=>x?.value)
            return ({...template, toEmail, _id,  campaignId, htmlBody: htmlVersion(templateHtml, _id)})
        }
        return emptyDoc()
    }

    const loadingData = async() => {    
        const users = await initialUsers
        const clients = await initialClients
        const template = await emailTemplate
        return ({users, clients, template})     
        }   
    const initialDocument =  () => loadingData()?.then((data)=>{
        const template = data?.template
        const users = data?.users
        const clients = data?.clients
        if(template) {
            const _id = template?._id ? template?._id : uuidv4()
            const templateHtml = draftToHtml(template?.richEditorObj)
            const toEmail = emailType == "email" ? users?.map?.(x=>x?.value) : clients?.map?.(x=>x?.pec)
            const doc = {...template, toEmail, _id,  htmlBody: htmlVersion(templateHtml, _id)}
            //console.log("diewhdiuwedhd", doc)
            setValue(doc)
            setEmails(users)
            setPecs(clients)
            return (doc)
        }
        setValue(emptyDoc())
        setEmails([])
        setPecs([])
        return emptyDoc()
    })
    useEffect(()=>{
        initialDocument()
    },[emailTemplate])   
   

    const [emails, setEmails] = useState()
    const [pecs, setPecs] = useState()
    const [value, setValue] = useState()
    const [existingRichDoc, setExistingRichDoc] = useState(emailTemplate?.richEditorObj)

    const postingEmailToSanity = async(email, result=()=>{}) => {

        console.log("======POSTING MESSAGE=======", JSON.stringify(email), apiUrl)
        const response = await fetch(`${apiUrl}/email/save-user-email`,{
          method:"POST",
          body: JSON.stringify(email),
          headers: new Headers({'content-type': 'application/json'}), 
        })
        const dataResponse = await response.json()
        console.log("new data post",dataResponse)        
      }

    const testFunction = () => {
        console.log("TEST EMAIL", value)
        //postingEmailToSanity(value)

        
    }
    const update = (value) => {
        //setLaws([...filteredArray, value])
        
        const queryDoc = {
            doc: value,
        }
        console.log("SAVE:", queryDoc)
    }
    const editorDocDescription = (data) => {
        //console.log("EDITOR DOC", data)
        const htmlDraft = draftToHtml(data)
        //const imageTag = `<img src=${pixelImageTrackingUrl} width="1" height="1" alt="" />`


        const newValue = {...value, htmlBody: `${htmlVersion(htmlDraft, value?._id)}`, richEditorObj: {...data, blocks: data?.blocks?.map?.((x)=>({...x, _key: keyId()}))}}
        // <img src="/assets/tracking.gif" width="1" height="1" alt="tracking-pixel"
        //http://yourserver.com/tracking.gif?email=recipient@example.com
        //<img src=       

        setValue(newValue)
        //setLaws([...filteredArray, newValue])
    }
    const clearFields = () => {
        setValue(emptyDoc())
        setEmails([])
        setPecs([])
        setExistingRichDoc({})
    }
    const emailResult = (result) =>{
        if(result?.Success == "SUCCESS") {
            clearFields()
            console.log("SPEDITO", value, result)
        }
        else {errorAlert(result?.message)}
    }
    const postingEmailExpress = async(data, result=()=>{}) => {
    
        console.log("SENDING EMAIL", JSON.stringify(data))
       
        const response = await fetch(`${apiUrl}/email/send-email`,{
          method:"POST",
          headers: new Headers({'content-type': 'application/json'}), 
          body: JSON.stringify(data),

        })
        const dataResponse = await response.json()
        console.log("emailDataResponse",dataResponse)
        result(dataResponse)
        
      }


    const sendEmail = (e) => {
        e.preventDefault();
        const queue = new PromiseQueue({
            concurrency: 1,
            intervalCap: 1,
            interval: 1000,
          })
          for(const emailAddress of value?.toEmail) {
              queue.add(() => {
                console.log(`SPEDITO A ${emailAddress}`)
                const _id = uuidv4()
                const campaignId = uuidv4()
                const templateHtml = draftToHtml(value?.richEditorObj)
                const email = {...value, _id, campaignId, service, toEmail: emailAddress, htmlBody: htmlVersion(templateHtml, _id) }
                return  postingEmailExpress(email)
              }) 
          }
          console.log("SPEDITO TUTTO")
          clearFields()
 
      }

 

  return (
        <VisDiv className={"new-device-container"} rules={[true]} style={{padding: "10px"}}> 
   {/*          <button onClick={testFunction}>test email</button>  */}
            <VisDiv style={{display:"flex", justifyContent:"flex-start", marginBottom:"10px"}}>
                <button className='blue-button' onClick={clearFields}>resetta i campi</button>
            </VisDiv>
            
            <form onSubmit= {sendEmail} target='_top'>
        {/*     <TextField
                    //defaultValue={value?.toEmail} 
                    label={"Indirizzi email (separati dalla virgola)"}
                    value = {value?.toEmail}
                    type="email"
                    multiple={true}
                    onChange={(e) => {setValue({...value, toEmail: e.target.value})}}
                /> */}
                    <VisDiv rules={[emailType == "email"]}>
                        <h4>Indirizzi Email:</h4>
                        <FieldDropdown
                            isMulti={true}
                            isSearchable="isSearchable"
                            initialValue={emails}
                            placeHolder={"ASSEGNA EMAIL"}
                            options={usersOptions}
                            onChange={(emailValue) => {
                                const emailAddressesArray = emailValue?.map?.((x)=>x?.value)
                                setEmails(emailValue)
                                setValue({...value, toEmail: emailAddressesArray})
                            }
                            }
                        />
                    </VisDiv>
                    <VisDiv rules={[emailType == "pec"]}>
                        <h4>Indirizzi Pec:</h4>
                        <FieldDropdown
                            isMulti={true}
                            isSearchable="isSearchable"
                            initialValue={pecs}
                            placeHolder={"ASSEGNA PEC"}
                            options={clientsOptions}
                            onChange={(pecValue) => {
                                const pecAddressesArray = pecValue?.map?.((x)=>x?.pec)
                                setPecs(pecValue)
                                setValue({...value, toEmail: pecAddressesArray})
                            }
                            }
                        />
                    </VisDiv>

                <TextField
                    //defaultValue={value?.subject} 
                    label={"Soggetto"}
                    value = {value?.subject}
                    type="text"
                    onChange={(e) => {setValue({...value, subject: e.target.value})}}
                />
                <h4>E-mail</h4>
                <RichTextEditor 
                    fullWidth={true}
                    onBlur={()=>update(value)} 
                    noFocus={true} 
                    existingDoc={existingRichDoc} 
                    editorDoc={editorDocDescription}
                    updateInitialData={true}
                    
                    />
                    <VisDiv style={{display:"flex", justifyContent:"center"}}>
                        <input className='blue-button' style={{backgroundColor:"green"}} value={"Invia"} type="submit"></input>
                    </VisDiv>
         
            </form>
    </VisDiv>
  )
}

export default RichEmail
